module.exports = __webpack_public_path__ + "static/media/storm.d4745cdc.jpg";